//---------------Stage Config--------------------

let config = {
  AdminAPIURL: "https://admin-api.jewelcloud.com/api",
  DealerAPIURL: "https://dealer-api.jewelcloud.com/api",
  CatalogAPIURL: "https://catalog-api.jewelcloud.com/api",
  CommunityAPIURL: "https://community-api.jewelcloud.com/api",
  AppsAPIURL: "https://apps-api.jewelcloud.com/api",
  PurchaseOrderAPIURL: "https://purchaseorder-api.jewelcloud.com/api",
  MarketingUploadAPIURL: "https://marketing-api.jewelcloud.com/api",
  AdminReportURL: "https://report-api.jewelcloud.com/api",
  IdleTimer: 3600000,
  // Iframe URLs for Apps
  StudBuilderURL: "https://studbuilder.jewelcloud.com",
  RingBuilderURL: "https://ringbuilder.jewelcloud.com",
  PendantBuilderURL: "https://pendantbuilder.jewelcloud.com",
  DiamondLinkURL: "https://diamondlink.jewelcloud.com",
  MasterLinkURL: "https://masterlink.jewelcloud.com",
  WatchCustomizerURL: "https://jc2-wtchcustmizer.mgr.brainvire.net",
  BlobURL: "https://jewelcloudstagingdiag.blob.core.windows.net/",
  ImageURL: "https://media.jewelcloud.com/"
};

export default config;
